import React, {useEffect, useState} from "react";
import DashboardPanel from "../../../components/DashboardPanel";
import {withWarehousePackages} from "../../../lib/WarehouseHelper";
import OrderWithPackages from "./OrderWithPackages";


// In the Pack panel, packages are grouped by their jobId.
// Along the general info, each package's sku is displayed along with
// a scanner button to match their tracking number
const Panel = (props) => {
  const {
    warehouseId, packages,
    getJobById, getAlertInfoForJobId, getTagsForJobId,
  } = props;
  
  // Packages are grouped by jobId
  const [orders, setOrders] = useState({});

  useEffect(() => {
    setOrders(packages.reduce((acc, p) => {
      const jobId = p.get("jobId");

      if (!acc[jobId]) {
        // Init order info
        acc[jobId] = {
          ...getJobById(jobId),
          id: jobId, // keep in mind as the acc keys will be thrown away
          packages: [],
          alert: getAlertInfoForJobId(jobId),
          tags: getTagsForJobId(jobId),
        }
      }

      // We just need to know the number of packages
      acc[jobId].packages.push(p);

      return acc;
    }, {}));
  }, [packages, getJobById, getAlertInfoForJobId, getTagsForJobId]);

  return (
    <DashboardPanel title="Pack" theme="packing">
      { Object.values(orders).map((o) =>
          <OrderWithPackages key={o.id} {...o}
            warehouseId={warehouseId}
          />)
      }
    </DashboardPanel>
  );
}

export default withWarehousePackages(Panel);